import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { router } from './router'
import { useThemeStore } from './stores/theme'
import { vNoBackdropClose } from './directives/noBackdropClose'

import '@tabler/icons-webfont/tabler-icons.min.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/components.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.directive('no-backdrop-close', vNoBackdropClose)

// 主题 store 在 createPinia 之后才能 use，必须在 mount 前同步 attr 一次，
// 否则 page-bg 闪烁（第一帧用默认主题、下一帧切到用户偏好）。
useThemeStore().applyToDom()

app.mount('#app')
